<template>
  <div>
    <b-row class="mb-2 mt-2">
      <AiDashboardCard
        v-for="item in cards"
        :key="item.id"
        :title="item.title"
        :month.sync="item.month"
        :formatted-total="item.getTotal(dataCard[item.id])"
        :percentage="dataCard[item.id].percentage"
        :last-month-text="item.getLastMonthText(dataCard[item.id])"
        @month-change="handleMonthChange(item.id)"
      />
    </b-row>
    <b-row class="mt-2">
      <b-col
        md="7"
        class="p-1"
      >
        <ConversionRateChart />
      </b-col>
      <b-col
        md="5"
        class="p-1"
      >
        <TokenDistributionChart />
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col
        md="4"
        class="p-1"
      >
        <PaymentMethodChart />
      </b-col>
      <b-col
        md="8"
        class="p-1"
      >
        <LogActivity />
      </b-col>
    </b-row>
    <b-row class="mt-2 mb-2">
      <b-col
        md="12"
        class="p-1"
      >
        <TotalClosingOrder />
      </b-col>
    </b-row>
    <b-row class="mt-2 mb-2">
      <b-col
        md="12"
        class="p-1"
      >
        <DataAgentCard />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { IDRWithoutLbl } from '@/libs/currency'
import moment from 'moment'
import { START_DATE_OF_MONTH, END_DATE_OF_MONTH } from '@/libs/filterDate'
import AiDashboardCard from '../components/AiDashboardCard.vue'
import ConversionRateChart from '../components/ConversionRateChart.vue'
import TokenDistributionChart from '../components/TokenDistributionChart.vue'
import PaymentMethodChart from '../components/PaymentMethodChart.vue'
import LogActivity from '../components/LogActivity.vue'
import TotalClosingOrder from '../components/TotalClosingOrder.vue'
import DataAgentCard from '../components/DataAgentCard.vue'
import {
  apiDataSpending, apiDataTokens, apiDataUserActive, apiDataTotalLeads,
} from '../services/api.komchat.service'

import { formatShortNumber } from '../config'

export default {
  components: {
    AiDashboardCard,
    ConversionRateChart,
    TokenDistributionChart,
    PaymentMethodChart,
    LogActivity,
    TotalClosingOrder,
    DataAgentCard,
  },
  data() {
    return {
      moment,
      IDRWithoutLbl,
      cards: [
        {
          id: 'spends',
          title: 'Total Spends',
          month: moment(),
          getTotal: data => `Rp ${IDRWithoutLbl(data.total)}`,
          getLastMonthText: data => `Spend last month: Rp ${IDRWithoutLbl(data.lastMonth)}`,
        },
        {
          id: 'tokens',
          title: 'Total Tokens',
          month: moment(),
          getTotal: data => formatShortNumber(data.total),
          getLastMonthText: data => `Token last month: ${formatShortNumber(data.lastMonth)}`,
        },
        {
          id: 'users',
          title: 'Users Active',
          month: moment(),
          getTotal: data => `${data.total}`,
          getLastMonthText: data => `User active last month: ${data.lastMonth}`,
        },
        {
          id: 'leads',
          title: 'Total Leads',
          month: moment(),
          getTotal: data => `${data.total}`,
          getLastMonthText: data => `Leads last month: ${data.lastMonth}`,
        },
      ],
      dataCard: {
        spends: { total: 0, percentage: '0%', lastMonth: 0 },
        tokens: { total: 0, percentage: '0%', lastMonth: 0 },
        users: { total: 0, percentage: '0%', lastMonth: 0 },
        leads: { total: 0, percentage: '0%', lastMonth: 0 },
      },
    }
  },
  mounted() {
    this.getData('spends')
    this.getData('tokens')
    this.getData('users')
    this.getData('leads')
  },
  methods: {
    handleMonthChange(type) {
      this.getData(type)
    },
    async getData(type) {
      const card = this.cards.find(c => c.id === type)
      const selectedMonth = card ? card.month : moment()

      const startDate = START_DATE_OF_MONTH(selectedMonth)
      const endDate = END_DATE_OF_MONTH(selectedMonth)

      const apiMethods = {
        spends: apiDataSpending,
        tokens: apiDataTokens,
        users: apiDataUserActive,
        leads: apiDataTotalLeads,
      }

      try {
        const fetchMethod = apiMethods[type]
        if (!fetchMethod) return

        const res = await fetchMethod({ startDate, endDate })

        if (res && res.data && res.data.data) {
          const { now, percentage, last } = res.data.data
          this.dataCard[type].total = now || 0
          this.dataCard[type].percentage = percentage || '0%'
          this.dataCard[type].lastMonth = last || 0
        } else {
          this.dataCard[type].total = 0
          this.dataCard[type].percentage = '0%'
          this.dataCard[type].lastMonth = 0
        }
      } catch (err) {
        console.error('Failed to fetch data for', type, err)
      }
    },
  },
}
</script>

<style>
.month-picker .month-year-display.input{
  width: 120px;
}
</style>
